import React from "react";
import Accordion from "./Accordion";

class RoleSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: null,
    };
    this.activateTab = this.activateTab.bind(this);
  }

  activateTab(index) {
    this.setState((prev) => ({
      activeTab: prev.activeTab === index ? -1 : index,
    }));
  }

  render() {
    const { activeTab } = this.state;
    const { roles, onRoleChanged, role: selectedRoleId } = this.props;

    return (
      <div className="job-accordions" role="tablist">
        {roles.map((role, index) => {
          return (
            <Accordion
              key={role.id}
              activeTab={activeTab}
              index={index}
              selectedRoleId={selectedRoleId}
              roleDetails={role}
              onRoleChanged={onRoleChanged}
              activateTab={this.activateTab.bind(null, index)}
            />
          );
        })}
      </div>
    );
  }
}

export default RoleSelect;



// WEBPACK FOOTER //
// ./src/components/Modals/Company/RoleSelect.js